export default __webpack_public_path__ + "static/homepageVideoPoster-16ab872231a1cd52c04e2d79ae5435fc.webp";